// extracted by mini-css-extract-plugin
export default {"item":"navigation-item_item__Z+Cqc"};